// extracted by mini-css-extract-plugin
export default {"loader":"_3e385c5d","billingAddress":"_5c124b11","addressForm":"_affbb08c","spinner":"_9fd92f51","error":"_9d5a5574"};